import {Group} from '../../../shared';
import * as group from '../actions/group.action';

export interface State {
  idList: string[];
  entities: { [id: number]: Group };
  selectedId: string | null;
  loading: boolean;
}

export const initialState: State = {
  idList: [],
  entities: {},
  selectedId: null,
  loading: false
};

/**
 * Because our object state tree is read-only, our response for every action
 * must return a new state object without mutating the previous state object.
 */

export function reducer(state = initialState, action: group.Actions): State {
  switch (action.type) {
    case group.REQUEST_SUCCESS: {
      const groupList: Group[] = <Group[]>action.payload;
      const newEntities = groupList.reduce(
        (entities: { [id: string]: Group }, eachGroup: Group) => {
          return {...entities, [eachGroup.id]: eachGroup};
        }, {});
      const idList: string[] = Object.keys(newEntities).map((key: string) => key);

      return {
        ...state,
        idList,
        entities: newEntities,
        loading: false
      };
    }

    case group.REQUEST_FAIL: {
      console.warn('GROUP: Request Fail');
      return {...state, loading: false};
    }

    case group.CREATE_FAIL: {
      console.warn('GROUP: Create Fail');
      return {...state, loading: false};
    }

    case group.SELECT_GROUP: {
      const selectedId: string = <string>action.payload;
      return {...state, selectedId};
    }
    case group.DESELECT_GROUP: {
      return {...state, selectedId: null}
    }
    default:
      return state;
  }
};

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;
export const getIdList = (state: State) => state.idList;
export const getSelectedId = (state: State) => state.selectedId;
export const getLoadingStatus = (state: State) => state.loading;
